import { render, staticRenderFns } from "./ProductImageItem.vue?vue&type=template&id=0b1ce4c1&scoped=true"
import script from "./ProductImageItem.vue?vue&type=script&lang=js"
export * from "./ProductImageItem.vue?vue&type=script&lang=js"
import style0 from "./ProductImageItem.vue?vue&type=style&index=0&id=0b1ce4c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ce4c1",
  null
  
)

export default component.exports